query Landinpages($id: String) {
  company(id: $id) {
    id
    slug
    country
    productType
    variant
    site {
      id
      url
    }
    landingpages {
      id
      type
      name
      slug
      topicId
      originalUrl
      customUrl
      conversionCount
      status
      template {
        id
        createdAt
      }
    }
    currentContract {
      endDate
    }
    state {
      value
    }
  }
}
